import IntroKeypad from './IntroKeypad';
import SeqQuizIntro from './SeqQuizIntro';
import SeqQuizIntro2 from './SeqQuizIntro2';
import SeqQuiz from './SeqQuiz';
import KeypadGame from './KeypadGameSlide';
import SeqQuizOutro from './SeqQuizOutro';

export default [IntroKeypad, SeqQuizIntro, SeqQuizIntro2, SeqQuiz, SeqQuizOutro, KeypadGame];
